import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import * as Yup from "yup";
import Edit from "../../../../src/assets/images/editinput.svg";
import { Select } from "@appkit4/react-components/select";
import { Combobox, TextArea } from "@appkit4/react-components";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import displayToastMessage from "../../Common/Alert/displayToastMessage";
import { Tooltip } from '@appkit4/react-components/tooltip';


import { handleNotificationSubmit } from "../notification/notification";
import PropTypes from "prop-types";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
export default function EditViewIssues(prop) {
  let { updateIssueId, vendors, analyst, reload, View, priorityList } = prop;
  const [loading, setLoading] = useState(false);
  const [modalVisible, setmodalVisible] = useState(false);
  const [riskName, setRiskName] = useState();
  const [currentTab, setCurrentTab] = useState("1");
  const [filterRiskId, setFilterRiskId] = useState([]);
  const [vendorid, setVendorid] = useState();
  const [assessmentId, setAssessmentId] = useState();
  const [remediationPlan, setRemediationPlan] = useState("");
  const [errorRemidiationplan, setErrorRemidiationplan] = useState("");
  const [title, setTitle] = useState("");
  const [errorTitle, setErrorTitle] = useState("");
  const [description, setDescription] = useState("");
  const [errorDescription, setErrorDescription] = useState("");
  const [workPerformed, setWorkPerformed] = useState("");
  const [errorWorkPerformed, setErrorWorkPerformed] = useState("");
  const [isErrorMessageShown, setIsErrorMessageShown] = useState(false);
  const { sendRequest: updateViewIssuesAPI } = useHttp();
  const { sendRequest: handleNotificationSubmitAPI } = useHttp();
  const { sendRequest: getManageRiskById } = useHttp();
  const { sendRequest: getAssessmentRiskById } = useHttp();
  const { sendRequest: getRiskDataById } = useHttp();
  const [comments, setComments] = useState("");
  const [commentsFormat, setCommentsFormat] = useState(false);
  const { sendRequest: downloadAPI } = useHttp();

  

  useEffect(() => {
    getAssessmentRisk(updateIssueId.vendor_id);
    // getRiskData(updateIssueId.vendor_id);
    // if (updateIssueId.risk_id !== null) {
    //   getRiskNameById(updateIssueId.risk_id);
    // }
  }, []);

  const handleTabs = (e, v) => {
    setCurrentTab(v);
  };
  // const getRiskNameById = async (riskID) => {
  //   getManageRiskById(APIService.getManageRiskById(riskID), (data) => {
  //     setRiskName(data.MSG[0].service_name);
  //   })
  // };
  const getAssessmentRisk = async (ThirdPartyID) => {
    getAssessmentRiskById(APIService.getAssessmentRiskById(ThirdPartyID), (data) => {
      setAssessmentId(data.MSG);
      setVendorid(data.MSG[0].vendor_id);
    })
  };
  const getRiskData = async (ThirdPartyID) => {
    getRiskDataById(APIService.getRiskDataById(ThirdPartyID), (data) => {
      setFilterRiskId(data.MSG);
    })
  };

  const updateViewIssuesResponse = (data, resetForm) => {
    if (data.CODE) {
      resetForm();
      setLoading(false);
      prop.handleBack();
      setmodalVisible(false);
      reload();
      let notifData = {
        paramuserid: Number(sessionStorage.getItem("userId")),
        paramreqid: updateIssueId && updateIssueId.vendor_user_id,
        paramcontent: "Issue updated successfully",
        paramnextroleid: 5,
        paramcreatedby: Number(sessionStorage.getItem("roleId")),
        parammsgtype: data.MSG,
      };
      handleNotificationSubmitAPI(
        APIService.handleNotificationSubmit(notifData),
        () => {}
      );
      displayToastMessage(data.MSG, "success");
    } else {
      let Msg = "Action failed. Please try again!";
      setLoading(false);
      prop.handleBack();
      setmodalVisible(false);
      displayToastMessage(Msg, "error");
    }
  };
  const handelSubmit = async (values, { resetForm }) => {

    setLoading(true);
    let issueData = {
      IssueID: updateIssueId?.issue_id,
      Approval: values.Approval,
      AssessmentID: values.AssessmentID,
      ControlName: values.ControlName,
      ControlQuestionID: values.ControlQuestionID,
      IssueDetails: values.IssueDetails,
      IssueDueDate: values.IssueDueDate,
      IssueType: values.IssueType,
      Rating: 0,
      RemediationPlan: values.RemediationPlan,
      RiskID: 0,
      // RiskName: values.RiskName,
      ThirdPartyName: values.ThirdPartyName,
      Title: values.Title,
      CreationDate: values.CreationDate,
      Description: values.Description,
      StartDate: values.StartDate,
      EndDate: values.EndDate,
      WorkPerformed: values.WorkPerformed,
      created_by: Number(sessionStorage.getItem("userId")),
      vendorID: vendorid,
      IssueStatus: 1,
      email:sessionStorage.getItem("email"),
      issue_action_id:updateIssueId?.issue_action_id,
      userName: sessionStorage.getItem("username"),
      Issue_Comments: comments,


    };
    await updateViewIssuesAPI(
      APIService.updateViewIssues(issueData),
      (res) => updateViewIssuesResponse(res, resetForm),
      (error) => {
        console.log("Error", error);
        setLoading(false);
        prop.handleBack();
        setmodalVisible(false);
        let Msg = "Action failed. Please try again!";
        displayToastMessage(Msg, "error");
      }
    );
  };
  function formatDate(date) {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  let validateInputFields = (value) => {
    let reg = /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/;
    if (value.match(reg)) {
      return true;
    } else {
      return false;
    }
  };

  const handleRemediationPlan = (e) => {
    if (e.target.value === "") {
      setErrorRemidiationplan("");
      setRemediationPlan(e.target.value);
    } else {
      if (validateInputFields(e.target.value)) {
        setErrorRemidiationplan("");
        setRemediationPlan(e.target.value);
      } else {
        setIsErrorMessageShown(true);
        setErrorRemidiationplan("Special characters are not allowed");
      }
    }
  };

  const handleChangeTitle = (e) => {
    if (e.target.value === "") {
      setErrorTitle("");
      setTitle(e.target.value);
    } else {
      if (validateInputFields(e.target.value)) {
        setErrorTitle("");
        setTitle(e.target.value);
      } else {
        setIsErrorMessageShown(true);
        setErrorTitle("Special characters are not allowed");
      }
    }
  };

  const handleChangeDescription = (e) => {
    if (e.target.value === "") {
      setErrorDescription("");
      setDescription(e.target.value);
    } else {
      if (validateInputFields(e.target.value)) {
        setErrorDescription("");
        setDescription(e.target.value);
      } else {
        setIsErrorMessageShown(true);
        setErrorDescription("Special characters are not allowed");
      }
    }
  };

  const handleChangeWorkPerformed = (e) => {
    if (e.target.value === "") {
      setErrorWorkPerformed("");
      setWorkPerformed(e.target.value);
    } else {
      if (validateInputFields(e.target.value)) {
        setErrorWorkPerformed("");
        setWorkPerformed(e.target.value);
      } else {
        setIsErrorMessageShown(true);
        setErrorWorkPerformed("Special characters are not allowed");
      }
    }
  };
  let initialValues = {
    ThirdPartyName:
      updateIssueId ? updateIssueId.vendor_id : "",
    AssessmentID:
      updateIssueId ? updateIssueId.assessment_id : "",
    IssueDetails:
      updateIssueId ? updateIssueId.issue_details : "",
    Rating: updateIssueId ? updateIssueId.issue_rating : "",
    CreationDate: formatDate(
      updateIssueId ? updateIssueId.created_date : ""
    ),
    IssueDueDate: formatDate(
      updateIssueId ? updateIssueId.issuedue_date : ""
    ),
    IssueType: updateIssueId ? updateIssueId.issuetype : "",
    RiskID: updateIssueId ? updateIssueId.risk_id : "",
    // RiskName: "",
    ControlQuestionID:
      updateIssueId ? updateIssueId.controlquestionid : "",
    ControlName:
      updateIssueId ? updateIssueId.control_name : "",
    RemediationPlan:
      updateIssueId ? updateIssueId.remediationplan : "",
    Approval:
      updateIssueId ? updateIssueId.approval_analyst : "",
    Title: updateIssueId ? updateIssueId.title_action : "",
    Description:
      updateIssueId ? updateIssueId.description : "",
    StartDate: formatDate(
      updateIssueId ? updateIssueId.startdate : ""
    ),
    EndDate: formatDate(
      updateIssueId ? updateIssueId.enddate : ""
    ),
    WorkPerformed:
      updateIssueId ? updateIssueId.workperformed : "",
  };

  const handleChangeComment = (e) => {
    if (e.search(/[^()0-9a-zA-Z,. ]/) === -1) {
      setCommentsFormat(false);
    } else {
      setComments();
      setCommentsFormat(true);
    }
    setComments(e);
  };
  const splitData=updateIssueId?.evidencedetails?.split(',');


  const downloadResponseHandler = (result, fileName) => {
    if (result) {
      const blob = new Blob([result?.data], {
        type: "application/octet-stream",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
      displayToastMessage("File Downloaded successfully", "success");
    }
  };

  const getDownloadFile = async (data, fileName) => {
    await downloadAPI(
      APIService.downloadFile(data,'issue'),
      (res) => downloadResponseHandler(res, fileName),
      (err) => {
        let MSG = "Something went wrong, Please try again!";
        displayToastMessage(MSG, "error");
      },
      true
    );
  };
  return (
    <div>
      <div className="row text-end pt-3">
        <div className="col-md-12">
          <span className="cv-input-label me-4">
            Issue ID : {"ISSUE"}
            {updateIssueId && updateIssueId.issue_id}{" "}
          </span>
          <span className="cv-input-label me-3">
            Status :{" "}
            <span className="upadte-status Close-status me-4 status-widget">
              {" "}
              {updateIssueId?._status}
            </span>
          </span>
          <span
            className="Appkit4-icon icon-arrow-left-outline pointer back-fill"
            onClick={prop.handleBack}
          ></span>
        </div>
      </div>
      <Formik
        initialValues={initialValues}
        onSubmit={handelSubmit}
        validationSchema={Yup.object().shape({
          ThirdPartyName: Yup.string()
            .required("Third party name is Required.")
            .matches(
              /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
              "Only alphabets and numbers are allowed for this field "
            ),
          AssessmentID: Yup.string()
            .required("Assessment ID is Required.")
            .matches(
              /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
              "Only alphabets and numbers are allowed for this field "
            ),
          IssueDetails: Yup.string()
            .required("Issue details is Required.")
            .matches(
              /^[a-zA-Z\d\-_.,&#()\s]+$/,
              "Only alphabets, numbers and some special characters are allowed for this field "
            ).nullable(),
         
          CreationDate: Yup.string().required("Creation date is Required."),
          IssueDueDate: Yup.string().required("Issue due date is Required."),
         
          // RiskID: Yup.string()
          //   .required("Risk ID is Required.")
          //   .matches(
          //     /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
          //     "Only alphabets and numbers are allowed for this field "
          //   ),
          //RiskName: Yup.string().required("Risk name is Required."),
          ControlQuestionID: Yup.string()
            .required("Control/question ID is Required.")
            .matches(
              /^[a-zA-Z\d\-_.,&#()\s]+$/,
              "Only alphabets, numbers and some special characters are allowed for this field "
            ),
          ControlName: Yup.string()
            .required("Control name is Required."),
            // .matches(
            //   /^[a-zA-Z\d\-_.,&#()\s]+$/,
            //   "Only alphabets, numbers and some special characters are allowed for this field"
            // ),
          Approval: Yup.string()
            .required("Approval is Required.")
            .matches(
              /^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$/,
              "Only alphabets and numbers are allowed for this field "
            ),
        })}
        enableReinitialize={true}
      >
        {(props) => {
          const {
            values,
            touched,
            errors,
            handleChange,
            handleBlur,
            handleSubmit,
          } = props;
          return (
            <div className="">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Third Party Name <span className="asterisk-required">*</span>
                      </label>
                      <Select
                        className="cv-input-field"
                        dropdownRenderMode="portal"
                        data={vendors}
                        valueKey="vendor_id"
                        labelKey="vendor_name"
                        onSelect={(e) => {
                          handleChange("ThirdPartyName")({
                            target: { value: e },
                          });
                          getAssessmentRisk(e);
                          getRiskData(e);
                        }}
                        name="ThirdPartyName"
                        value={values.ThirdPartyName}
                        placeholder="Select Third Party Name"
                      ></Select>
                    </div>
                    {errors.ThirdPartyName && touched.ThirdPartyName && (
                      <div className="form-label error">
                        {errors.ThirdPartyName}
                      </div>
                    )}
                  </div>

                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label className="cv-input-label">
                        Assessment <span className="asterisk-required">*</span>
                      </label>
                      <select
                        className="cv-input-field"
                        type="text"
                        value={values.AssessmentID}
                        onChange={handleChange("AssessmentID")}
                        name="AssessmentID"
                      >
                        <option key="0">Select Assessment Name</option>
                        {assessmentId?.map((each, index) => {
                            return (
                              <option key={index} value={each.assessment_id}>
                                {each.assessment_name}
                              </option>
                            );
                          })}
                      </select>
                    </div>
                    {errors.AssessmentID && touched.AssessmentID && (
                      <div className="form-label error">
                        {errors.AssessmentID}
                      </div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                  <div className="cv-input-field-container">
                      <label htmlFor="IssueDueDateViewIssues" className="cv-input-label">
                        Issue Due Date <span className="asterisk-required">*</span>
                      </label>
                      <input
                        name="IssueDueDate"
                        type="date"
                        id="IssueDueDateViewIssues"
                        placeholder="IssueDueDate"
                        value={values.IssueDueDate}
                        onChange={handleChange("IssueDueDate")}
                        onBlur={handleBlur}
                        className="cv-input-field pl-1 "
                      />
                    </div>
                    {errors.IssueDueDate && touched.IssueDueDate && (
                      <div className="error-msg">{errors.IssueDueDate}</div>
                    )}
                  </div>
                  <div className="col-sm-6">
                    <div className="cv-input-field-container">
                      <label htmlFor="CreationDateViewIssues" className="cv-input-label">
                        Creation Date <span className="asterisk-required">*</span>
                      </label>
                      <input
                        name="CreationDate"
                        type="date"
                        id="CreationDateViewIssues"
                        placeholder="CreationDate"
                        value={values.CreationDate}
                        onChange={handleChange("CreationDate")}
                        onBlur={handleBlur}
                        className="cv-input-field pl-1"
                      />
                    </div>
                    {errors.CreationDate && touched.CreationDate && (
                      <div className="error-msg">{errors.CreationDate}</div>
                    )}
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-6">
                      <div className="cv-input-field-container">
                      <label htmlFor="IssueDetailsViewIssues" className="cv-input-label">
                        Issue Details <span className="asterisk-required">*</span>
                      </label>
                    
                      <textarea  
                        name="IssueDetails"
                        type="text"
                        id="IssueDetailsViewIssues"
                        placeholder="Please enter issue details"
                        value={values.IssueDetails}
                        onChange={handleChange("IssueDetails")}
                        onBlur={handleBlur}
                        className="cv-input-field "
                      />
                  
                  {values.IssueDetails && <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        className="tooltipData"
        appendAfterTarget={true}
        content={values.IssueDetails}
      >  <img alt="edit" src={Edit} className="edit-input" /></Tooltip>}
                    </div>
                    {errors.IssueDetails && touched.IssueDetails && (
                      <div className="error-msg">{errors.IssueDetails}</div>
                    )}
                  </div>
                </div>
                <div className="mt-3">
                  <Tabs
                    defaultValue={currentTab}
                    value={currentTab}
                    onChange={handleTabs}
                    className="a-tab-item-padding-10"
                  >
                   
                    <Tab value="3" label="Control/Question Mapping">
                      <div className="col-sm-6 mt-3">
                        <div className="cv-input-field-container">
                          <label htmlFor="ControlQuestionIDViewIssues" className="cv-input-label">
                            Control/ Question ID <span className="asterisk-required">*</span>
                          </label>
                          <input
                            name="ControlName"
                            type="text"
                            id="ControlQuestionIDViewIssues"
                            placeholder="ControlQuestionID"
                            value={values.ControlQuestionID}
                            onChange={handleChange("ControlQuestionID")}
                            onBlur={handleBlur}
                            className="cv-input-field ml-3"
                            disabled
                          />
                          <img alt="edit" src={Edit} className="edit-input" />
                          {/* <Select
                            className="cv-input-field"
                            onBlur={handleBlur}
                            onSelect={(e) =>
                              handleChange("ControlQuestionID")({
                                target: { value: e },
                              })
                            }
                            name="ControlQuestionID"
                            value={values.ControlQuestionID}
                            multiple
                            placeholder="Select Control Question ID"
                          >
                            <SelectGroupTitle>
                              Select Control/Question ID
                            </SelectGroupTitle>
                            <SelectOption key="1" value={1}>
                              Tier-1
                            </SelectOption>
                            <SelectOption key="2" value={2}>
                              Tier-2
                            </SelectOption>
                          </Select> */}
                        </div>
                        {errors.ControlQuestionID &&
                          touched.ControlQuestionID && (
                            <div className="form-label error">
                              {errors.ControlQuestionID}
                            </div>
                          )}
                      </div>

                      <div className="col-sm-6 mt-2">
                        <div className="cv-input-field-container">
                          <label htmlFor="ControlNameViewIssues" className="cv-input-label">
                            Control Name <span className="asterisk-required">*</span>
                          </label>
                          <input
                            name="ControlName"
                            type="text"
                            id="ControlNameViewIssues"
                            placeholder="ControlName"
                            value={values.ControlName}
                            onChange={handleChange("ControlName")}
                            onBlur={handleBlur}
                            className="cv-input-field ml-3"
                            disabled
                          />
                          <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        appendAfterTarget={true}
        content={values.ControlName}
      >
                          <img alt="edit" src={Edit} className="edit-input" /></Tooltip>
                        </div>
                        {errors.ControlName && touched.ControlName && (
                          <div className="error-msg">{errors.ControlName}</div>
                        )}
                      </div>
                    </Tab>
                    <Tab value="4" label="Remediation Plan">
                      <div className="col-sm-6 mt-3">
                        <div className="cv-input-field-container">
                          <label className="cv-input-label">
                            Remediation Plan
                          </label>
                          <textarea
                            name="RemediationPlan"
                            type="text"
                            placeholder="Please enter RemediationPlan"
                            value={values.RemediationPlan}
                            onChange={handleChange("RemediationPlan")}
                            className="cv-input-field"
                          />
                         <Tooltip
        trigger='hover'
        position='top-left'
        distance={4}
        id="tooltipDesc"
        className="tooltipData"
        appendAfterTarget={true}
        content={values.RemediationPlan}
      > <img alt="edit" src={Edit} className="edit-input" /> </Tooltip>
                        </div>
                        {/* <div className="cv-input-field">
                          <span
                            className="form-label errorMsg"
                            style={{
                              display: isErrorMessageShown ? "block" : "none",
                            }}
                          >
                            {errorRemidiationplan}
                          </span>
                        </div> */}
                      </div>
                      <div className="col-sm-6 mt-3">
                         <label htmlFor="RemediationPlanEditIssue" className="cv-input-label">
                         Evidence </label>
                        {splitData?.map((val,i)=>{
                          return  <div onClick={()=>getDownloadFile(val.split('#$%')[1],val.split('#$%')[0])} className="hyperText">{val.split('#$%')[0]} </div>

                          })}
                          </div>
                    </Tab>
                    <Tab value="5" label="Add Action">
                      <div className="col-sm-6 mt-3">
                        <div className="cv-input-field-container">
                          <label className="cv-input-label">Title</label>
                          <input
                            name="Title"
                            type="text"
                            placeholder="Please enter title"
                            value={values.Title}
                            onChange={handleChange("Title")}
                            className="cv-input-field"
                          />
                          <img alt="edit" src={Edit} className="edit-input" />
                        </div>
                        {/* <div className="cv-input-field">
                          <span
                            className="form-label errorMsg"
                            style={{
                              display: isErrorMessageShown ? "block" : "none",
                            }}
                          >
                            {errorTitle}
                          </span>
                        </div> */}
                      </div>
                      <div className="col-sm-6 mt-2">
                        <div className="cv-input-field-container">
                          <label className="cv-input-label">Description</label>
                          <input
                            name="Description"
                            type="Description"
                            id="Description"
                            placeholder="Please enter description"
                            value={values.Description}
                            onChange={handleChange("Description")}
                            className="cv-input-field"
                          />
                          <img alt="edit" src={Edit} className="edit-input" />
                        </div>
                        {/* <div className="cv-input-field">
                          <span
                            className="form-label errorMsg"
                            style={{
                              display: isErrorMessageShown ? "block" : "none",
                            }}
                          >
                            {errorDescription}
                          </span>
                        </div> */}
                      </div>
                      <div className="col-sm-6 mt-2">
                        <div className="cv-input-field-container">
                          <label htmlFor="StartDateViewIssues" className="cv-input-label">Start Date</label>
                          <input
                            name="StartDate"
                            type="date"
                            id="StartDateViewIssues"
                            placeholder="StartDate"
                            value={values.StartDate}
                            onChange={handleChange("StartDate")}
                            onBlur={handleBlur}
                            className="cv-input-field"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 mt-2">
                        <div className="cv-input-field-container">
                          <label htmlFor="EndDateViewIssues" className="cv-input-label">End Date</label>
                          <input
                            name="EndDate"
                            type="date"
                            id="EndDateViewIssues"
                            placeholder="EndDate"
                            value={values.EndDate}
                            onChange={handleChange("EndDate")}
                            onBlur={handleBlur}
                            className="cv-input-field"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6 mt-2">
                        <div className="cv-input-field-container">
                          <label htmlFor="WorkPerformedViewIssues" className="cv-input-label">
                            Work Performed
                          </label>
                          <input
                            name="WorkPerformed"
                            type="text"
                            id="WorkPerformedViewIssues"
                            placeholder="Please enter work performed"
                            value={values.WorkPerformed}
                            onChange={handleChange("WorkPerformed")}
                              onBlur={handleBlur}
                            className="cv-input-field"
                          />
                          <img alt="edit" src={Edit} className="edit-input" />
                        </div>
                        {/* <div className="cv-input-field">
                          <span
                            className="form-label errorMsg"
                            style={{
                              display: isErrorMessageShown ? "block" : "none",
                            }}
                          >
                            {errorWorkPerformed}
                          </span>
                        </div> */}
                      </div>
                    </Tab>
                    <Tab value="6" label="Approval">
                      <div className="col-sm-6 mt-3">
                        <div className="cv-input-field-container">
                          <label className="cv-input-label">
                            Analyst <span className="asterisk-required">*</span>
                          </label>
                          <select
                            className="cv-input-field"
                            type="text"
                            value={values.Approval}
                            onChange={handleChange("Approval")}
                            name="Approval"
                          >
                            <option key="0">Select Analyst</option>
                            {analyst?.map((each, index) => {
                                return (
                                  <option key={index} value={each.analyst_id}>
                                    {each.analyst_name}
                                  </option>
                                );
                              })}
                          </select>
                        </div>
                        {errors.Approval && touched.Approval && (
                          <div className="error-msg">{errors.Approval}</div>
                        )}
                      </div>
                    </Tab>
                  </Tabs>
                </div>
                <div className="row">
                  <div className="col-sm-6 mt-1">
                    <label className="cv-input-label">Vendor Comments</label>
                    <TextArea
                      name="vendorComments"
                      type="text"
                      id="vendorComments"
                      readonly={true}
                      className="cv-input-field input-field-border"
                      value={
                        updateIssueId.vendor_comments !== null
                          ? updateIssueId?.vendor_comments
                          : ""
                      }
                    />
                  </div>
                </div>
                <div className="row">
                    <div className="col-sm-6 mt-1 ">
                      <label className="cv-input-label">Assessor Comment</label>
                      <TextArea
                        name="Comment"
                        type="text"
                        placeholder="Please add comment"
                        value={comments?comments:updateIssueId.assessorcomment}
                        onChange={handleChangeComment}
                        className="cv-input-field input-field-border"
                      />
                      {commentsFormat && (
                        <label className="requiredComments">
                          Only alphabets and some special characters are allowed
                          for this field
                        </label>
                      )}
                    </div>
                  </div>

                <div className="options-container">
                  {View && (
                    <button type="submit" className="save-button m-l-2">
                      Update
                    </button>
                  )}
                  <button
                    className="cancel-button m-l-2"
                    type="reset"
                    onClick={prop.handleBack}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            </div>
          );
        }}
      </Formik>
      {/* <ConformationModal
        name={"Comments"}
        visible={modalVisible}
        cancel={handleCancel}
      /> */}
    </div>
  );
}

EditViewIssues.propTypes = {
  values: PropTypes.any,
  touched: PropTypes.any,
  errors: PropTypes.any,
  handleChange: PropTypes.any,
  handleBlur: PropTypes.any,
  handleSubmit: PropTypes.any,
}